<div class="config-value">
  @if (isFlag) {
    <select
      id="{{ identifier }}{{ valueSuffix }}"
      name="{{ identifier }}{{ valueSuffix }}"
      class="form-select"
      required
      [ngClass]="{ 'is-invalid': !!valueValidationError }"
      (ngModelChange)="onValueChange($event)"
      [ngModel]="value"
      [disabled]="!definition.editable"
      >
      @for (option of flagOptions; track option) {
        <option
          [disabled]="option[1] === undefined"
          [hidden]="option[1] === undefined"
          [value]="option[1]"
          >
          {{ option[0] }}
        </option>
      }
    </select>
  }
  @if (!isFlag) {
    <input
      type="text"
      id="{{ identifier }}{{ valueSuffix }}"
      name="{{ identifier }}{{ valueSuffix }}"
      ngDefaultControl
      required
      class="form-control"
      [ngClass]="{ 'is-invalid': !!valueValidationError }"
      (ngModelChange)="onValueChange($event)"
      [disabled]="!definition.editable"
      [ngModel]="value"
      />
  }
  @if (valueValidationError && valueValidationError.message) {
    <div class="invalid-feedback">
      {{ valueValidationError.message }}
    </div>
  }
</div>
